import React from 'react';

const Success = () => {
    return (
        <div>
            <p className='text-center'>Yor Payment is complet</p>
        </div>
    );
};

export default Success;